import { init } from "@rematch/core";
import persistPlugin from "@rematch/persist";
import * as models from "./models";
import storage from "redux-persist/lib/storage";

export const store = init({
  models,
  plugins: [
    persistPlugin({
      key: "root",
      storage,
      version: 2,
      whitelist: ["config"],
    }),
  ],
});

export default store;
